import { Editor, Transforms } from 'slate';
import { HistoryEditor } from 'slate-history';
import * as serializer from 'basic-editor-value-serializer';

// Puts starter content into one empty header region and selects its text, ready to type over.
export function fillRegion(editor, path, role, options) {
  const nodes = serializer.utilities.node.siteNav.buildStarterContent(role, options);
  HistoryEditor.withNewBatch(editor, function fillHeaderRegion() {
    Editor.withoutNormalizing(editor, function placeContent() {
      Transforms.removeNodes(editor, { at: path.concat(0) });
      Transforms.insertNodes(editor, nodes, { at: path.concat(0) });
    });
    Transforms.select(editor, Editor.range(editor, path.concat(0)));
  });
}
